import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Contact_ServiceDeskOpeningHoursResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetOpeningHoursContactServiceDesk = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Get the openinghours of the customer contact desk for BE
 *
 * @returns ResponseModels_Contact_ServiceDeskOpeningHoursResponseModel Success
 */
export function getOpeningHoursContactServiceDesk(
  { businessUnit, label, customerId }: GetOpeningHoursContactServiceDesk,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Contact_ServiceDeskOpeningHoursResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/contact/desk`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
